import React from 'react';

import PropTypes from 'prop-types';

import S from './styles';

function PageHeader({ extra, onBack, subTitle, title }) {
  return (
    <S.PageHeader title={title} subTitle={subTitle} extra={extra} onBack={onBack} ghost={false} />
  );
}

PageHeader.defaultProps = {
  extra: null,
  onBack: null,
  subTitle: '',
  title: '',
};

PageHeader.propTypes = {
  extra: PropTypes.element,
  onBack: PropTypes.func,
  subTitle: PropTypes.string,
  title: PropTypes.string,
};

export default PageHeader;
